import config from '../../config';

export default {
  url: config.oada.url,
  token: '',
  path: '/bookmarks/trellisfw',
  data: {
  }
}
